type ScrollDirection = 'back' | 'forward';

class GeneralItemContainer {
  private readonly slider: HTMLElement | null;
  private readonly arrowLeft: HTMLElement | null;
  private readonly arrowRight: HTMLElement | null;
  private readonly arrowContainer: HTMLElement | null;

  constructor(container: HTMLElement) {
    this.slider = container.querySelector('.no-columns-set .general-items-row');
    this.arrowLeft = container.querySelector('.arrow');
    this.arrowRight = container.querySelector('.arrow-right');
    this.arrowContainer = container.querySelector('.arrow-container');

    if (!this.slider) {
      return;
    }

    this.bindEvents();
    this.renderArrows();
  }

  private bindEvents(): void {
    this.arrowLeft?.addEventListener('click', () => this.horizontalScroll('back'));
    this.arrowRight?.addEventListener('click', () => this.horizontalScroll('forward'));
    window.addEventListener('resize', () => this.renderArrows());
    this.slider?.addEventListener('scroll', () => this.renderArrows());
  }

  private horizontalScroll(direction: ScrollDirection): void {
    const slider = this.slider;
    if (!slider) {
      return;
    }

    let scrollAmount = 0;
    const slideTimer = window.setInterval(() => {
      slider.scrollLeft += direction === 'back' ? -70 : 70;

      this.setArrowsFromScrollStates();
      scrollAmount += 70;
      if (scrollAmount >= 500) {
        window.clearInterval(slideTimer);
      }
    }, 27);
  }

  private renderArrows(): void {
    const slider = this.slider;
    if (!slider) {
      return;
    }

    if (slider.scrollWidth > slider.clientWidth) {
      this.arrowContainer?.classList.add('d-lg-flex');
      slider.classList.add('has-overflow');
      this.setArrowsFromScrollStates();
    } else {
      this.arrowContainer?.classList.add('d-none');
      this.arrowContainer?.classList.remove('d-lg-flex');
      slider.classList.remove('has-overflow');
    }
  }

  private setArrowsFromScrollStates(): void {
    const slider = this.slider;
    if (!slider) {
      return;
    }

    if (slider.scrollWidth - 1 < slider.clientWidth + slider.scrollLeft) {
      this.arrowRight?.classList.add('disabled');
    } else {
      this.arrowRight?.classList.remove('disabled');
    }

    if (slider.scrollLeft === 0) {
      this.arrowLeft?.classList.add('disabled');
    } else {
      this.arrowLeft?.classList.remove('disabled');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll<HTMLElement>('.general-item-container').forEach((container) => {
    new GeneralItemContainer(container);
  });
});
